import styled from 'styled-components';

export const FooterContainer = styled.footer`
    min-height: 172px;
    padding: 40px 0;
    color: ${props => props.theme.footerTextColor};
    margin-top: auto;
    background: ${props => props.theme.footerBackgroundColor};

    a {
        color: ${props => props.theme.footerTextColor};
        text-decoration: none;
    }

    .link {
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }

    ul {
        margin: 0;
        padding: 0;
        list-style-type: none;

        li {
            margin: 0 0 5px;

            &:last-child {
                margin: 0;
            }

            a:hover {
                text-decoration: underline;
            }
        }
    }

    hr {
        background: ${props => props.theme.footerTextColor};
    }

    .reseaux-sociaux {
        p {
            margin: 0 0 10px;
        }

        a {
            width: 57px;
            height: 57px;
            margin-right: 30px;

            &:last-child {
                margin: 0;
            }
        }
    }

    .mobile-app .button-wrapper {
        display: flex;
        margin-top: 20px;
        white-space: nowrap;

        a + a {
            margin-left: 20px;
        }

        .download-btn {
            width: 150px;
        }
    }

    @media screen and (max-width: ${props => props.theme.large}) {
        height: auto;
        padding: 30px 0;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .reseaux-sociaux {
            margin: 30px 0;
        }

        .mobile-app {
            margin-top: 20px;

            .button-wrapper {
                flex-wrap: wrap;
                margin-top: 0;

                a + a {
                    margin-left: 0;
                }

                a {
                    margin: 20px 20px 0 0;
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponentStyle.js